var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"award-message"},[_c('div',{staticClass:"award-message-title"},[_vm._v(_vm._s(_vm.$t("invitation.inviteAwardTitle")))]),_c('div',{staticClass:"award-message-content"},[_c('div',{staticClass:"award-message-icon"}),_c('div',[_vm._v(_vm._s(_vm.awardDays)+_vm._s(_vm.$t("invitation.day")))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }